export function getDraftCreationInitialValues(payload) {
  return payload?.initialValues
}

export function getDraftCreationSubmitPayload(payload, initialValues) {
  return { ...payload, initialValues }
}
